import { AxiosError } from 'axios'
import { Dispatch } from 'redux'

import * as Api from 'redux/api/DataPlatform/connections/sourceTables/v1'
import { TSourceTableBody } from 'redux/api/DataPlatform/connections/sourceTables/v1'

import { toggleSnackbarOpen } from '../../../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryUpdateSourceTable(
  sourceTableId: string,
  body: TSourceTableBody,
  activeSourceId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    Api.update(sourceTableId, body)
      .then((response) => {
        dispatch(actions.updateSuccess({ ...response.data, activeSourceId }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
      })
  }
}

export function tryGetSourceTablePreview(
  id: string,
  limit: number,
  offset: number
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getPreview({ id }))

    Api.getPreview(id, limit, offset)
      .then((response) => {
        dispatch(
          actions.getPreviewSuccess({ data: response.data, limit, offset })
        )
      })
      .catch(() => {
        dispatch(actions.getPreviewFailed())
      })
  }
}

export function tryDeleteSourceTable(
  id: string,
  activeSourceId: string,
  callbacks: { onConflict?: () => void; onSuccess?: () => void } = {}
) {
  const { onSuccess, onConflict } = callbacks

  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    Api.deleteSourceTable(id)
      .then((response) => {
        dispatch(
          actions.destroySuccess({
            ...response.data,
            activeSourceId,
            deletedId: id
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        if (onSuccess) {
          onSuccess()
        }
      })
      .catch((error: AxiosError) => {
        dispatch(actions.destroyFailed())

        if (error.response?.status === 409 && onConflict) {
          onConflict()
        } else {
          dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))
        }
      })
  }
}

export const useSourceTableActions = () => {
  return {
    tryDeleteSourceTable: useThunkActions(tryDeleteSourceTable),
    tryGetSourceTablePreview: useThunkActions(tryGetSourceTablePreview),
    tryUpdateSourceTable: useThunkActions(tryUpdateSourceTable)
  }
}
